import { useEffect, useRef, useState } from 'react'

let targetRefs = [] // all A components
let observers = [] // observers per target
let subscribers = [] // all B/C components

// compute if any target is visible
const computeVisibility = () => {
  const states = targetRefs.map((r) => {
    if (!r.current) return false
    const rect = r.current.getBoundingClientRect()
    return rect.top < window.innerHeight && rect.bottom > 0
  })
  return states.some(Boolean)
}

// notify all subscribers
const notifySubscribers = () => {
  const visible = computeVisibility()
  subscribers.forEach((fn) => fn(visible))
}

export function useVisibilityGroup(options = { threshold: 0.1 }, isTarget = false) {
  const localRef = useRef(null)
  const [anyVisible, setAnyVisible] = useState(true)

  useEffect(() => {
    let observer // define here so cleanup can access it

    if (isTarget) {
      // register this target
      targetRefs.push(localRef)

      const element = localRef.current
      if (element) {
        observer = new IntersectionObserver(notifySubscribers, options)
        observer.observe(element)
        observers.push(observer)
      }

      // immediately notify subscribers
      notifySubscribers()

      return () => {
        targetRefs = targetRefs.filter((r) => r !== localRef)
        if (observer) observer.disconnect()
        observers = observers.filter((obs) => obs !== observer)
        notifySubscribers()
      }
    } else {
      // subscriber (B or C)
      subscribers.push(setAnyVisible)

      // immediately set current visibility
      setAnyVisible(computeVisibility())

      return () => {
        subscribers = subscribers.filter((fn) => fn !== setAnyVisible)
      }
    }
  }, [isTarget, options])

  return { ref: localRef, anyVisible }
}
